module.exports = __webpack_public_path__ + "static/media/MobileSellkeyFunction03.8d47a899.png";